import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@material-ui/core';

import { ReactComponent as OkIcon } from '../../../../assets/img/icon/Ok.svg';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const Documentation = () => {
  const { setStep, nextStep, updateAssistanceBody, cleanAssistanceBody } =
    useAssistanceDataContext();
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const { user, embed } = useAuthDataContext();

  const updateStep = () => {
    dataLayerPush('asistencia_cuentoConDocumentación', user?.id);
    updateAssistanceBody({
      has_required_documentation: true,
    });
    nextStep();
  };

  const cancelAssistance = () => {
    cleanAssistanceBody();
    setStep(0);
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Typography variant="h6"> ¡Atención! </Typography>
            <Box my={2}>
              <Typography>
                No podrás realizar el traslado del vehículo de no contar con la
                documentación completa y vigente.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={updateStep}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={cancelAssistance}
                >
                  Cancelar mi pedido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <Grid container>
        <Grid item xs={12}>
          <Box my={3}>
            <Typography variant="h6" color="textPrimary">
              Vamos a tener que trasladar el vehículo, es necesario que cuentes
              con:
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <List aria-label="detalles">
            <ListItem>
              <ListItemIcon>
                <OkIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2">
                    Si sos el titular DNI y cédula verde
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <OkIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography variant="body2">
                    Si sos adicional DNI, cédula azul y vas a tener que viajar
                    con el vehículo
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box my={3}>
            <Button
              onClick={() => setOpen(true)}
              variant="contained"
              color="primary"
            >
              Cuento con la documentación
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Documentation;
